const _create = require('./createComponent.js');
exports.createComponent = _create.createComponent;